import React from "react";
import ProfileForm from "../../components/ProfileForm";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import DismissedInvitations from "../../components/Notifications/DismissedInvitations";

const Profile = () => {
  const breadcrumbItems = [{ label: "Home", path: "/" }, { label: "Profile" }];

  return (
    <div className="min-h-screen bg-brand-cream py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center mb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>

        <div className="card-board overflow-hidden mb-6">
          <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
            <h1 className="font-display font-bold text-xl md:text-2xl text-brand-cream tracking-tight">
              Profile
            </h1>
            <p className="text-sm text-brand-mist mt-1">
              Name, phone, USBC ID, and password.
            </p>
          </div>
        </div>

        <div className="mb-6">
          <DismissedInvitations />
        </div>

        <ProfileForm />
      </div>
    </div>
  );
};

export default Profile;
